import React, { useEffect, lazy } from "react"
import { Routes, Route } from "react-router-dom"
import Layout from "./components/Layout"
import ReactGA from 'react-ga';

import Home from "./views/Home"
import Article from "./views/Article"
import Interviews from "./views/Interviews"
import Place from "./views/Place"
// import Ebook from "./views/Ebook"
// import Resource from "./views/Resource"

const TRACKING_ID = "G-F7QPLT4R31"; // OUR_TRACKING_ID

ReactGA.initialize(TRACKING_ID);


// const Home = lazy(() => wait(1000).then(() => import("./views/Home")))
// const Home = lazy(() => import("./views/Home"))
// const Ebook = lazy(() => import("./views/Ebook"))
// const Article = lazy(() => import("./views/Article"))
// const Resource = lazy(() => import("./views/Resource"))
// const Booking = lazy(() => import("./views/Booking"))
// const About = lazy(() => import("./views/About").then(module => {
//   return { default: module.About }
// }))

function App() {
  
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <Routes>
        <Route path="/" element={<Layout />} >
            <Route path="*" element={<Home />} />
            <Route path="/" element={<Home />} />
            <Route path="/news" element={<Article />} />
            <Route path="/special-interviews" element={<Interviews />} />
            <Route path="/interview/:articleId" element={<Interviews />} />
            <Route path="/article/:articleId" element={<Article />} />
            <Route path="/location/:placeId" element={<Place />} />
            <Route path="/location" element={<Place />} />
            <Route path="/about" element={<Article id="11" />} />
            <Route path="/services" element={<Article id="15" />} />
        </Route>
    </Routes>
  );
}

export default App;
